/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { ThemeOptions } from '@mui/material/styles';

export const dimensions: ThemeOptions = {
	dimensions: {
		contentSpacing: {
			xs: 2,
			sm: 2,
			md: 3,
			lg: 3,
		},
		dpSpacing: {
			spacing1: '4px',
			spacing2: '8px',
			spacing3: '12px',
			spacing4: '16px',
			spacing5: '20px',
			spacing6: '24px',
			spacing7: '32px',
			spacing8: '40px',
			spacing9: '48px',
			spacing10: '56px',
			spacing11: '',
			spacing12: '72px',
			spacing13: '80px',
			spacing14: '88px',
			spacing15: '96px',
		},
	},
};
